// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.safari .dropdown .dropdown-menu.sub-menu .fa-check {
  vertical-align: middle;
}

.dropdown-toggle:focus {
  outline: revert;
}

.dropdown {
  z-index: 4000;
}
.dropdown .dropdown-menu {
  width: 22.5rem;
  min-width: inherit;
}
.dropdown .dropdown-menu .caret-right {
  display: inline-block;
}
.dropdown svg {
  height: 2em;
}
.dropdown svg g path,
.dropdown svg path {
  fill: #4d4d4d;
}
.dropdown svg:hover g path,
.dropdown svg:hover path {
  fill: #dabc64;
}
.dropdown .dropdown-menu.sub-menu {
  top: 0.5rem;
  right: -14rem;
  width: 14rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown .dropdown-menu.sub-menu .menu-label {
  width: 11rem;
  cursor: pointer;
}
.dropdown .dropdown-menu.sub-menu .fa-check {
  vertical-align: super;
}
.dropdown .menu-label {
  display: inline-block;
  width: 16rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dropdown .dropdown-menu > li > span {
  padding: 0.3rem 1rem;
  position: relative;
}
.dropdown .dropdown-menu > li > a {
  padding: 0.3rem 1rem;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Layout/ApplicationNavigation/DropDown.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,sBAAA;AAEF;;AACA;EACE,eAAA;AAEF;;AACA;EACE,aCkBS;ADhBX;AADE;EACE,cAAA;EACA,kBAAA;AAGJ;AAFI;EACE,qBAAA;AAIN;AADE;EACE,WAAA;AAGJ;AAFI;;EAEE,aDJI;ACQV;AADM;;EAEE,aDRQ;ACWhB;AACE;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;AAAI;EACE,YAAA;EACA,eAAA;AAEN;AAAI;EACE,qBAAA;AAEN;AACE;EACE,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;AAEE;EACE,oBAAA;EACA,kBAAA;AAAJ;AAEE;EACE,oBAAA;EACA,kBAAA;AAAJ","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import 'Colors.scss';\n@import 'Variables.scss';\n\n.safari .dropdown .dropdown-menu.sub-menu .fa-check {\n  vertical-align: middle;\n}\n\n.dropdown-toggle:focus {\n  outline: revert;\n}\n\n.dropdown {\n  z-index: $navLayer;\n  .dropdown-menu {\n    width: 22.5rem;\n    min-width: inherit;\n    .caret-right {\n      display: inline-block;\n    }\n  }\n  svg {\n    height: 2em;\n    g path,\n    path {\n      fill: $navIcon;\n    }\n    &:hover {\n      g path,\n      path {\n        fill: $navIconActive;\n      }\n    }\n  }\n  .dropdown-menu.sub-menu {\n    top: 0.5rem;\n    right: -14rem;\n    width: 14rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    .menu-label {\n      width: 11rem;\n      cursor: pointer;\n    }\n    .fa-check {\n      vertical-align: super;\n    }\n  }\n  .menu-label {\n    display: inline-block;\n    width: 16rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .dropdown-menu > li > span {\n    padding: 0.3rem 1rem;\n    position: relative;\n  }\n  .dropdown-menu > li > a {\n    padding: 0.3rem 1rem;\n    position: relative;\n  }\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
